import React from 'react'
import PropTypes from 'prop-types'
import { Card, Empty, Timeline, Typography } from 'antd'
import { ACTION_LABELS, formatDateTime, money } from './utils'

// A re-track spends a credit and a refund moves money, so those two read differently from the rest
// of the log at a glance.
const KIND_COLORS = { retrack: 'blue', manual_refund: 'purple', close: 'gray' }

// The specifics that make a line worth reading: which number was swapped for which, and how much
// went back.
const detailFor = action => {
  if (action.kind === 'retrack') {
    return `${action.oldNumber || '—'} (${action.oldLineName || '—'}) → ${
      action.newNumber || '—'
    } (${action.newLineName || '—'}) · ShipsGo ${action.oldShipsgoId || '—'} → ${
      action.newShipsgoId || '—'
    }`
  }
  if (action.kind === 'manual_refund') {
    return `${money(action.amount, action.currency)} · Paystack ${
      action.paystackReference || '—'
    }`
  }
  return null
}

// Who did what, and when — the reason nobody has to guess whether somebody already rang this
// customer. Newest first, as the server sends it.
const ActionLog = ({ actions }) => {
  const rows = actions || []

  return (
    <Card title="Action log">
      {rows.length ? (
        <Timeline>
          {rows.map(action => {
            const detail = detailFor(action)
            return (
              <Timeline.Item
                key={action.id}
                color={KIND_COLORS[action.kind] || 'blue'}
              >
                <Typography.Text strong>
                  {ACTION_LABELS[action.kind] || action.kind}
                </Typography.Text>
                {detail ? <div>{detail}</div> : null}
                {action.note ? <div>{action.note}</div> : null}
                <div style={{ opacity: 0.65 }}>
                  {`${formatDateTime(action.createdAt)} · ${action.actor || '—'}`}
                </div>
              </Timeline.Item>
            )
          })}
        </Timeline>
      ) : (
        <Empty description="No team actions yet." />
      )}
    </Card>
  )
}

ActionLog.propTypes = {
  actions: PropTypes.array
}

export default ActionLog
